import React from 'react';

import { useField } from 'formik';

import Input from '../input/Input';
import TextArea from '../textarea/Textarea';
import FormItem from './FormItem';

const FormText: React.FC<{
  formItemProps?: any;
  label: string;
  name: string;
  value?: string;
  placeholder?: string;
  mask?: string;
  readonly?: boolean;
  keyfilter?: string;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  isTextArea?: boolean;
  labelClassNames?: string;
  formControlClassName?: string;
  helpText?: string;
}> = (props) => {
  const [field, meta] = useField({ name: props.name });

  const handleChange = (event: any) => {
    field.onChange(event);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  const handleBlur = (event: any) => {
    field.onBlur(event);

    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  // Show nothing if readonly is true and value is empty
  if (props.readonly && !meta.value) {
    return null;
  }

  const {
    isTextArea,
    formControlClassName,
    labelClassNames,
    helpText,
    formItemProps,
    ...rest
  } = props;

  return (
    <FormItem
      {...props.formItemProps}
      label={props.label}
      for={props.name}
      name={props.name}
      labelClassNames={props.labelClassNames}
      formControlClassName={props.formControlClassName}
      helpText={props.helpText}
    >
      {isTextArea ? (
        <TextArea
          {...rest}
          id={props.name}
          name={props.name}
          placeholder={props.placeholder || props.label}
          value={meta.value}
          readOnly={props.readonly}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`form-control`}
        />
      ) : (
        <Input
          {...rest}
          id={props.name}
          name={props.name}
          placeholder={props.placeholder || props.label}
          value={meta.value}
          readOnly={props.readonly}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`form-control`}
        />
      )}
    </FormItem>
  );
};

export default FormText;
